/* 
©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved. */


window.sbBehaviours = window.sbBehaviours || {};
sbBehaviours.retailDashboardBehavior = {
    getDataForIds: function (list, urlForId, callback) {
        var self = this;
        var finalList = [];
        var counter = 0;

        if (list.length > 0) {
            for (var i = 0; i < list.length; i++) {
                self.dispatchEvent(new CustomEvent('start-processing-loader', {
                    bubbles: true,
                    composed: true
                }));
                var ajaxCall = document.createElement('oe-ajax');
                ajaxCall.contentType = "application/json";
                ajaxCall.handleAs = "json";
                ajaxCall.url = urlForId + "/" + list[i].accountId;
                ajaxCall.method = 'get';
                ajaxCall.addEventListener('response', function (event) {
                    var tempList = event.detail.response;
                    finalList = finalList.concat(tempList);
                    counter++;

                    if (counter == list.length) {
                        self.dispatchEvent(new CustomEvent('stop-processing-loader', {
                            bubbles: true,
                            composed: true
                        }));
                        callback(finalList);
                    }
                });
                ajaxCall.addEventListener("error", function (e) {
                    showAjaxError(e);
                    self.dispatchEvent(new CustomEvent('stop-processing-loader', {
                        bubbles: true,
                        composed: true
                    }));
                });
                ajaxCall.generateRequest();
            }
        }
    },
    navigateToDashboard: function (data) {
        window.localStorage.setItem('username', data.username);
        var self = this;
        if (data.preferredTimeZone) {
            clientStorage.set(storageType.session, 'preferredTimeZone', data.preferredTimeZone);
            var offset = data.preferredTimeZone.cmCode.split("GMT")[1];
            var minutes = 0;
            if (offset) {
                var sign = offset[0];
                var timeParts = offset.slice(1).split(":");
                //Convert into milliseconds
                minutes = (timeParts[0] ? Number(timeParts[0]) * 60 : 0) + (timeParts[1] ? Number(timeParts[1]) : 0) + (timeParts[2] ? Number(timeParts[2]) / 60 : 0)
            }
            clientStorage.set(storageType.session, 'preferredTimezone', (sign == "-") ? -Math.abs(minutes) : minutes);
            window.OEUtils.componentDefaults["oe-date"] = {
                referenceTimezone: (sign == "-") ? -Math.abs(minutes) : minutes
            };
            //Assign value in default  components of OEUtils
            OEUtils.componentDefaults["oe-info"] = OEUtils.componentDefaults["oe-info"] || {};
            OEUtils.componentDefaults["oe-info"]["preferredTimezone"] = clientStorage.get(storageType.session, 'preferredTimezone');
        }
        (data.uniqueUserId!=undefined) ? clientStorage.set(storageType.session, 'uniqueUserId', data.uniqueUserId) : clientStorage.set(storageType.session, 'uniqueUserId', data.firstName);
        (data.principalId!=undefined) ? clientStorage.set(storageType.session, 'userId', data.principalId) : clientStorage.set(storageType.session, 'userId', data.userId);
        (data.orgId!=undefined) ? clientStorage.set(storageType.session, 'corpId', data.orgId) : clientStorage.set(storageType.session, 'corpId', data.corpId);
        (data.username!=undefined) ? clientStorage.set(storageType.session, 'username', data.username) : clientStorage.set(storageType.session, 'username', data.userId);
        clientStorage.set(storageType.session, 'firstName', data.firstName);
        clientStorage.set(storageType.session, 'dob', data.dob);
        //clientStorage.set(storageType.session, 'userId', data.userId);
        //clientStorage.set(storageType.session, 'corpId', data.corporateId);
        //clientStorage.set(storageType.session, 'username', data.username);
        //clientStorage.set(storageType.session, 'firstName', data.firstName);
        //clientStorage.set(storageType.local, 'username', data.username);
        //clientStorage.set(storageType.session, 'dateFormat', data.dateFormat);
        //clientStorage.set(storageType.session, 'amountFormat', data.amountFormat);
        //clientStorage.set(storageType.session, 'prospectIndicator', data.prospectIndicator);
        clientStorage.set(storageType.session, 'fullName', data.fullName.split(' ').filter(function (val) {
            if (val != "undefined" && val !== "null") return val
        }).join(' '));
        clientStorage.set(storageType.session, 'role', "consumer");
        (data.username!=undefined) ? clientStorage.set(storageType.local, 'username', data.username) : clientStorage.set(storageType.local, 'username', data.userId);
        (typeof data.dateFormat === 'object') ? clientStorage.set(storageType.session, 'dateFormat', data.dateFormat.codeDescription.toUpperCase()) : clientStorage.set(storageType.session, 'dateFormat', data.dateFormat);
        (typeof data.amountFormat === 'object') ? clientStorage.set(storageType.session, 'amountFormat', data.amountFormat.codeDescription) : clientStorage.set(storageType.session, 'amountFormat', data.amountFormat);
        (typeof data.prospectIndicator === 'object') ? clientStorage.set(storageType.session, 'prospectIndicator', data.dateFormat.prospectIndicator) : clientStorage.set(storageType.session, 'prospectIndicator', data.prospectIndicator);
        
        var lastLogin = "";
        if (data.lastLogin == undefined) {
            lastLogin = data.loginDate;
        }
        
        clientStorage.set(storageType.session, 'lastLogin', lastLogin);
        this.set('loggedInUserInfo', data);
        if (data.userMenus)
            this.set('menuProfiles', data.userMenus);
        self.token = "";
        if (data.theme)
            clientStorage.set(storageType.local, 'theme', (data.theme).toString());

        self.isCorporateUser = false;

        clientStorage.set(storageType.session, 'isCorporateUser', self.isCorporateUser);
        if (!self.isCorporateUser) clientStorage.set(storageType.session, 'customerId', data.cifId);
        /*Set Username in Cookies*/
        var toBeRemembered = data.fullName;
        // Code to check any part of name consists undefined word
        var temp = data.fullName.split(" ");
        var finalName = [];
        for (var i = 0; i < temp.length; i++) {
            if (temp[i] !== "undefined") {
                finalName.push(temp[i]);
            }
        }
        toBeRemembered = finalName.length > 0 ? finalName.join() : " ";
        toBeRemembered = toBeRemembered.replace(",", " ");
        var UserName = data.username;
        var userDetailsList = [];
        var temp = {};
        var tempBool = true;
        var tempUserDetails = escape(toBeRemembered) + '=' + escape(UserName);
        if (this.rememberMe) {
            if (localStorage.userDetails) {
                userDetailsList = JSON.parse(localStorage.userDetails).userDetailsList;
            }
            var userCount = 0;
            if (userDetailsList.length > 0) {
                /* removed this property from speedconfig to this element */
                if (userDetailsList.length >= self.maxUsers)
                    userCount = self.maxUsers;
                else
                    userCount = userDetailsList.length;
                for (let i = 0; i < userCount; i++) {
                    if (userDetailsList[i] === tempUserDetails) {
                        tempBool = false;
                        temp.userDetailsList = userDetailsList;
                        temp.prevLoggedIn = tempUserDetails;
                        // to store the value of isPrimaryAuthOtp in localstorage in case of remember username.
                        temp.isPrimaryAuthOtp = this.isPrimaryAuthOtp;
                        temp.isPrimaryAuthMPin = this.isPrimaryAuthMPin;
                        localStorage.userDetails = JSON.stringify(temp);
                        break;
                    }
                }
            }
            if (tempBool) {
                userDetailsList[userDetailsList.length] = tempUserDetails;
                temp.userDetailsList = userDetailsList;
                temp.prevLoggedIn = tempUserDetails;
                // to store the value of isPrimaryAuthOtp in localstorage in case of remember username.
                temp.isPrimaryAuthOtp = this.isPrimaryAuthOtp;
                temp.isPrimaryAuthMPin = this.isPrimaryAuthMPin;
                localStorage.userDetails = JSON.stringify(temp);
            }

        } else {
            if (localStorage.userDetails) {
                userDetailsList = JSON.parse(localStorage.userDetails).userDetailsList;
            }

            if (userDetailsList.length > 0) {
                for (let i = 0; i < userDetailsList.length; i++) {
                    if (userDetailsList[i] === tempUserDetails) {
                        var updatePrevLoggedIn = tempUserDetails;
                        var updatePrevLoggedInVal = JSON.parse(localStorage.userDetails);
                        updatePrevLoggedInVal.prevLoggedIn = updatePrevLoggedIn;
                        localStorage.userDetails = JSON.stringify(updatePrevLoggedInVal);
                    }
                }
            }


        }
        var previousUser = clientStorage.get(storageType.local, 'username');
        var currentUser = data.username;
        if (previousUser === undefined || previousUser === null || previousUser != currentUser) {
            clientStorage.set(storageType.local, 'isNotificationsEnabled', true);
        }
    },
    _getNavigationLinks: function () {
        var self = this;
        var ajaxCall = document.createElement('oe-ajax');
        ajaxCall.contentType = "application/json";
        ajaxCall.handleAs = "json";
        ajaxCall.url = '/api/CBNavigationLinks';
        ajaxCall.method = 'get';
        ajaxCall.params.filter = JSON.stringify(self._buildFilterParams(undefined));

        ajaxCall.addEventListener('response', function (event) {
            var response = event.detail.response;
            var navList = response;
            var navListPay = [];
            var navListRoot = [];
            var navListBottom = [];
            var navListStorage = {};
            for (var i = 0; i < navList.length; i++) {
                if (navList[i].group === "root") {
                    if (navList[i].url === '/' || navList[i] === '/admin') {
                        if (self.isCorporateUser)
                            navList[i].className = 'primary-background-200';
                        else
                            navList[i].className = 'secondary-brand-background';
                    } else {
                        navList[i].className = '';
                    }
                    navListRoot.push(navList[i]);
                } else if (navList[i].group === "pay")
                    navListPay.push(navList[i]);
                else if (navList[i].group === "bottom")
                    navListBottom.push(navList[i]);
            }

            navListRoot.sort(function (a, b) {
                return a.sequence - b.sequence;
            });
            navListStorage.pay = navListPay;
            navListStorage.bottom = navListBottom;
            navListStorage.root = navListRoot;
            navListStorage.all = navList;
            self.navigationLink = navListStorage;
            var mainbody = document.getElementById('mainbody');
            mainbody.menuProfiles = self.menuProfiles;
            mainbody.loggedin = true;
        });
        oeAjaxEventListner(ajaxCall);

        ajaxCall.generateRequest();
        //var scope = clientStorage.get(storageType.session, 'role');
        //this.shadowRoot.querySelector('literal-cache')._fetchLanguage(scope);
    },
    _buildFilterParams: function (parent) {
        var filter = {};
        filter.where = parent ? {
            parent: parent
        } : {
            topLevel: true
        };
        if (!parent) {
            var includeFilter = {
                relation: "children"
            };
            this.buildIncludeFilter(includeFilter, 2);
            filter.include = includeFilter;
        }
        // sorting the cbnavigationLink response based on sequence property as id property is removed now in json files
        filter.order = 'sequence ASC';
        return filter;
    },
    buildIncludeFilter: function (obj, level) {
        if (level == 1) return;
        obj.scope = {
            include: {
                relation: "children"
            }
        };
        this.buildIncludeFilter(obj.scope.include, --level);
    }

}
